<template>
    <div class="socialevents">
        <h2>Contact Us</h2>
        <p>Contact us today to schedule a tour, learn about membership options, or book your first tennis session at
            Lagos' premier tennis destination.</p>
        <div class="destination-container">
            <div class="destination-writeups">
                <h3>Visit Our Club</h3>
                <div class="contact-info">
                    <span>
                        <MailCheck />
                    </span>
                    <div>
                        <h2>Give us a call</h2>
                        <p>Phone: <a :href="'tel:' + dataList.phone">{{ dataList.phone }}</a></p>
                    </div>
                </div>
                <div class="contact-info">
                    <span>
                        <PhoneOutgoing />
                    </span>
                    <div>
                        <h2>Send us an email</h2>
                        <p>Email: <a :href="'mailto:' + dataList.email">{{ dataList.email }}</a></p>
                    </div>
                </div>
                <div class="contact-info">
                    <span>
                        <MapPin />
                    </span>
                    <div>
                        <h2>Visit us</h2>
                        <p>{{ dataList.address }}</p>
                    </div>
                </div>
            </div>
            <div class="card-container">
                <h2>Send us a message</h2>
                <form class="contact-form" @submit.prevent="submitForm">
                    <div class="name-email">
                        <!-- Full Name -->
                        <div class="form-group">
                            <label for="fullName">Full Name</label>
                            <input v-model="fullname" type="text" id="fullName" placeholder="Enter your full name" required />
                        </div>
                        <!-- Email -->
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input v-model="email" type="email" id="email" placeholder="Enter your email" required />
                        </div>
                    </div>
                    <div class="name-email">
                        <!-- Phone Number -->
                        <div class="form-group">
                            <label for="phone">Phone Number</label>
                            <input v-model="phone" type="tel" id="phone" placeholder="Enter your phone number" required />
                        </div>

                        <!-- Subject -->
                        <div class="form-group">
                            <label for="subject">Subject</label>
                            <input v-model="subject" type="text" id="subject" placeholder="Enter subject" required />
                        </div>
                    </div>

                    <!-- Message -->
                    <div class="form-group">
                        <label for="message">Message</label>
                        <textarea v-model="message" id="message" rows="8" placeholder="Write your message..." required></textarea>
                    </div>

                    <!-- Submit Button -->
                    <button type="submit" class="submit-btn">
                        <p>Send Message</p>
                        <ChevronRight />
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */ 
import { MailCheck, PhoneOutgoing, MapPin, ChevronRight } from "lucide-vue-next";
import { ref, onMounted  } from "vue";
import axios from 'axios';

const loggedId = ref(localStorage.getItem('userid'));
const created_by = ref(localStorage.getItem('userid'));
let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/";

const logoImage = ref('');
const dataList = ref('')


const fullname = ref('')
const email = ref('')
const phone = ref('')
const subject = ref('')
const message = ref('')

onMounted( async () => {
  await listLogo();
})


const listLogo = async () => {
  try {
    const response = await axios.get('/logo_lists.php', { });
   const logoData = response.data.data[0];
   dataList.value = response.data.data[0];
    logoImage.value = `${base_url}${logoData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

async function submitForm() {
    if (!fullname.value || !email.value || !phone.value || !subject.value || !message.value) {
        alert("Please fill in all fields.");
        return;
    }

    const formData = new FormData();
    formData.append("fullname", fullname.value);
    formData.append("email", email.value);
    formData.append("phone", phone.value);
    formData.append("subject", subject.value);
    formData.append("message", message.value);

    try {
        const response = await axios.post(
            "/about_contactus.php", // change to your backend URL
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
              
            }
        );

            alert(response.data.message);

            fullname.value = "";
            email.value = "";
            phone.value = "";
            message.value = "";
            subject.value = "";

            window.location.reload()
            
 
    } catch (error) {
        console.error(error);
        alert(error.response ? error.response.data.message : error.message);
    }
}

</script>

<style scoped lang="scss">
.socialevents {
    max-width: 100%;
    margin: auto;
    margin-top: 5rem;
    padding: 2rem;
    border-radius: 16px;
    background-color: #FFF9F8;

    h2 {
        max-width: 809px;
        margin: auto;
        font-size: 48px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        margin-bottom: 1rem;
        color: #171717;
        text-align: center;
    }

    p {
        max-width: 809px;
        margin: auto;
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        margin-bottom: 2rem;
        color: #555555;
        text-align: center;
    }
}

.destination-container {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin: auto;
    max-width: 80%;

    .destination-writeups {
        width: 475px;

        h3 {
            font-size: 24px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            margin-bottom: 1rem;
            color: #020617;
            text-align: left;
        }

        .contact-info {
            margin-bottom: 1rem;
            border: 1px solid #EBF1FF;
            background-color: #f9f9f9;
            display: flex;
            justify-content: start;
            gap: 30px;
            padding: 40px;
            border-radius: 16px;

            span {
                width: 56px;
                height: 56px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #94A3B880;
                border-radius: 50%;
                color: #ED4E24;
            }

            div {
                

                h2 {
                    font-size: 20px;
                    font-weight: 400;
                    color: #64748B;
                    font-family: "Open Runde", sans-serif;
                    margin-bottom: 8px;
                    padding: 0%;
                    text-align: left !important;
                }

                p {
                    font-size: 14px;
                    font-weight: 400;
                    font-family: "Open Runde", sans-serif;
                    color: #202124;
                    text-align: left;
                    margin: 0%;
                    max-width: 200px;
                    padding: 0%;
                }
            }
        }
    }

    .card-container {
        width: 611px;
        padding: 2rem;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    h2 {
        text-align: left;
        margin-bottom: 1.5rem;
        font-size: 24px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        color: #020617;
    }

    .contact-form {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
    }

    .name-email {
        display: flex;
        gap: 1rem;
        width: 100%;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        width: 100%;
    }

    label {
        margin-bottom: 0.5rem;
        font-weight: 400;
        font-size: 16px;
        font-family: "Open Runde", sans-serif;
        color: #020617;
    }

    input,
    textarea {
        padding: 0.75rem;
        border: 1px solid #94A3B8;
        border-radius: 8px;
        font-size: 16px;
        width: 100%;
        transition: border 0.3s;
    }

    input:focus,
    textarea:focus {
        border-color: #3b82f6;
        /* Tailwind blue-500 */
        outline: none;
    }

    .submit-btn {
        background: #ED4E24;
        color: #fff;
        border: none;
        padding: 0.9rem;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.3s;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;

        p {
            margin: 0;
            font-size: 1rem;
            font-weight: 600;
            font-family: "Open Runde", sans-serif;
            color: #ffffff;
        }
    }

    .submit-btn:hover {
        background: #2563eb;
        /* Darker blue */
    }
}

@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 5rem;
        padding: 10px;
        border-radius: 16px;
        background-color: #FFF9F8;

        h2 {
            width: 100%;
            margin: auto;
            font-size: 48px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            margin-bottom: 1rem;
            color: #171717;
            text-align: center;
        }

        p {
            width: 100%;
            margin: auto;
            font-size: 20px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            margin-bottom: 2rem;
            color: #555555;
            text-align: center;
        }
    }

    .destination-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: start;
        margin: auto;
        max-width: 100%;

        .destination-writeups {
            width: 100%;

            h3 {
                font-size: 24px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                margin-bottom: 1rem;
                color: #020617;
                text-align: left;
            }

            .contact-info {
                margin-bottom: 1rem;
                border: 1px solid #EBF1FF;
                background-color: #f9f9f9;
                display: flex;
                justify-content: start;
                align-items: center;
                gap: 30px;
                padding: 40px;
                border-radius: 16px;

                span {
                    width: 56px;
                    height: 56px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #94A3B880;
                    border-radius: 50%;
                    color: #ED4E24;
                }

                div {
                    display: flex;
                    flex-direction: column;
                    justify-content: start;
                    align-items: start;

                    h2 {
                        font-size: 20px;
                        font-weight: 400;
                        color: #64748B;
                        font-family: "Open Runde", sans-serif;
                        margin-bottom: 8px;
                        padding: 0%;
                    }

                    p {
                        font-size: 14px;
                        font-weight: 400;
                        font-family: "Open Runde", sans-serif;
                        color: #202124;
                        text-align: left;
                        margin: 0%;
                        max-width: 200px;
                        padding: 0%;
                    }
                }
            }
        }

        .card-container {
            width: 100%;
            padding: 2rem;
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        h2 {
            text-align: left;
            margin-bottom: 1.5rem;
            font-size: 24px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            color: #020617;
        }

        .contact-form {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            width: 100%;
        }

        .name-email {
            display: flex;
            gap: 1rem;
            width: 100%;
        }

        .form-group {
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: start;
            width: 100%;
        }

        label {
            margin-bottom: 0.5rem;
            font-weight: 400;
            font-size: 16px;
            font-family: "Open Runde", sans-serif;
            color: #020617;
        }

        input,
        textarea {
            padding: 0.75rem;
            border: 1px solid #94A3B8;
            border-radius: 8px;
            font-size: 16px;
            width: 100%;
            transition: border 0.3s;
        }

        input:focus,
        textarea:focus {
            border-color: #3b82f6;
            /* Tailwind blue-500 */
            outline: none;
        }

        .submit-btn {
            background: #ED4E24;
            color: #fff;
            border: none;
            padding: 0.9rem;
            border-radius: 8px;
            cursor: pointer;
            transition: background 0.3s;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;

            p {
                margin: 0;
                font-size: 1rem;
                font-weight: 600;
                font-family: "Open Runde", sans-serif;
                color: #ffffff;
            }
        }

        .submit-btn:hover {
            background: #2563eb;
            /* Darker blue */
        }
    }
}
</style>
